var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.persons),function(person){return _c('PoliticianAvatar',{key:person.id,staticClass:"ms-2 my-1",attrs:{"politician":person,"size":40}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }